export const summaryToggle = () => {

  document.querySelectorAll('.summary-header').forEach(function(button) {
      button.addEventListener('click', function() {
          const summary = this.closest('.summary');
          const isCollapsed = summary.classList.toggle('is-collapsed');
          this.setAttribute('aria-expanded', !isCollapsed);
      });
  });

}
